require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./set-up-inherited-widget-app-state.json") })
        }
      }, "path---set-up-inherited-widget-app-state");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---set-up-inherited-widget-app-state!./.cache/json/set-up-inherited-widget-app-state.json
// module id = 410
// module chunks = 231608221292675